import { HttpErrorResponse } from '@angular/common/http';
import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { ResponseList } from '@p2p/shared/domain';

import { CreateUserResponse } from '../entities/create-user-response';
import { UpsertUserData } from '../entities/upsert-user';
import { User } from '../entities/user';

import { UsersPageParams } from './users.model';

const actionFeatureKey = 'Users';

export const loadUsers = createAction(`[${actionFeatureKey}/API] Load users`, props<{ pageParams: UsersPageParams }>());
export const loadUsersSuccess = createAction(
    `[${actionFeatureKey}/API] Load users success`,
    props<ResponseList<User>>()
);
export const loadUsersFailure = createAction(
    `[${actionFeatureKey}/API] Load users failure`,
    props<{ error: HttpErrorResponse }>()
);

export const resetUsers = createAction(`[${actionFeatureKey}/API] Reset users`);

export const setPageParams = createAction(
    `[${actionFeatureKey}] Set page params`,
    props<{ pageParams: UsersPageParams }>()
);

export const createUser = createAction(`[${actionFeatureKey}/API] Create user`, props<{ user: UpsertUserData }>());
export const createUserSuccess = createAction(
    `[${actionFeatureKey}/API] Create user success`,
    props<CreateUserResponse>()
);
export const createUserFailure = createAction(
    `[${actionFeatureKey}/API] Create user failure`,
    props<{ error: HttpErrorResponse }>()
);

export const editUser = createAction(`[${actionFeatureKey}/API] Edit user`, props<{ user: UpsertUserData }>());
export const editUserSuccess = createAction(`[${actionFeatureKey}/API] Edit user success`);
export const editUserFailure = createAction(
    `[${actionFeatureKey}/API] Edit user failure`,
    props<{ error: HttpErrorResponse }>()
);

export const deleteUsers = createAction(`[${actionFeatureKey}/API] Delete user`, props<{ ids: User['id'][] }>());
export const deleteUsersSuccess = createAction(
    `[${actionFeatureKey}/API] Delete user success`,
    props<{ ids: User['id'][] }>()
);
export const deleteUsersFailure = createAction(
    `[${actionFeatureKey}/API] Delete user failure`,
    props<{ ids: User['id'][]; error: HttpErrorResponse }>()
);

export const changeUserBlocked = createAction(
    `[${actionFeatureKey}/API] Change user blocked`,
    props<{ id: User['id']; blocked: boolean }>()
);
export const changeUserBlockedSuccess = createAction(
    `[${actionFeatureKey}/API] Change user blocked success`,
    props<Update<User>>()
);
export const changeUserBlockedFailure = createAction(
    `[${actionFeatureKey}/API] Change user blocked failure`,
    props<{ id: User['id']; error: HttpErrorResponse }>()
);
